const otherHeight = {
  data() {
    return {
      tableHeight: 0
    }
  },
  methods: {
    getOtherHeight() {
      // 获取header高度
      let headerHeight = 0
      if (document.querySelector('.app-header')) {
        headerHeight = document.querySelector('.app-header').offsetHeight
      }
      // 获取tags-view-container高度
      let tagsViewHeight = 0
      if (document.querySelector('.tags-view-container')) {
        tagsViewHeight = document.querySelector('.tags-view-container').offsetHeight
      }
      // 获取app-main padding值
      let appMainPadding = 0
      if (document.querySelector('.app-container')) {
        appMainPadding = this.getStyle(document.querySelector('.app-container'), 'paddingTop') * 2
      }
      // 获取 search_list高度
      let searchHeight = 0
      if (document.querySelector('.search_list')) {
        searchHeight = document.querySelector('.search_list').offsetHeight
      }
      // 获取add-btn 高度
      let btnHeight = 0
      if (document.querySelector('.add-btn')) {
        btnHeight = document.querySelector('.add-btn').offsetHeight
      }
      // 获取add-btn padding值
      // let btnPadding = 0
      // if (document.querySelector('.add-btn')) {
      //   // btnPadding = this.getStyle(document.querySelector('.add-btn'), 'paddingTop') * 2
      // }

      // 获取 分页器高度
      let paginationHeight = 0
      if (document.querySelector('.pagination-container')) {
        paginationHeight = document.querySelector('.pagination-container').offsetHeight
      }
     // let paginationPadding = 0 60 41 20 140 47 52
    //  if(document.querySelector('.pagination-container')){
    //   paginationPadding = this.getStyle(document.querySelector('.pagination-container'), 'paddingTop') * 2
    //  }
    
      const otherHeight = headerHeight +
      tagsViewHeight +
      appMainPadding +
      searchHeight +
      // btnPadding +
      btnHeight +
      paginationHeight 
      // paginationPadding
      return otherHeight
    },
    getStyle(obj, attr) {
      if (obj.currentStyle) {
        return obj.currentStyle[attr].replace('px', '')
      } else {
        return document.defaultView.getComputedStyle(obj, null)[attr].replace('px', '')
      }
    }
  },
  mounted() {
    const otherHeight = this.getOtherHeight()
    const _this = this
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - otherHeight
    })
    window.onresize = function() {
      const otherHeight = _this.getOtherHeight()
      _this.$nextTick(() => {
        _this.tableHeight = window.innerHeight - otherHeight
      })
    }
    if(document.querySelector('.search-collapse')){
      document.querySelector('.search-collapse').addEventListener('click', function() {
        const otherHeight = _this.getOtherHeight()
        _this.$nextTick(() => {
          _this.tableHeight = window.innerHeight - otherHeight
        })
      })
    }
    
  }
}

export { otherHeight }
